import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { DiscountOrdinaryInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [
	"hotelID",
	"discountID",
	"isUncancelable",
	"staticTargetType",
	"staticTermType",
	"saleTypeForPlan",
	"saleTypeForTerm",
	"stayableDayOfTheWeek",
	"discountType",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DiscountOrdinaryFormModel = AutoGeneratorForFormModel<
	DiscountOrdinaryInputZodSchemaType,
	ExcludeKeys,
	undefined
>;
